import React, { FC, Suspense } from "react"
import type { StandaloneTaskAppProps } from "resha"
import { ErrorBoundary } from "../ErrorBoundary/ErrorBoundary"

const ReshaTaskLabelingApp = React.lazy(async () => {
    return import("resha").then(resha => ({ default: resha.StandaloneTaskApp }))
})

export const StandaloneTaskApp: FC<
    StandaloneTaskAppProps & { errorMessage: string; fallback: JSX.Element }
> = ({ errorMessage, fallback, ...props }) => {
    return (
        <ErrorBoundary message={errorMessage}>
            <Suspense fallback={fallback}>
                <ReshaTaskLabelingApp {...props} />
            </Suspense>
        </ErrorBoundary>
    )
}
